export default __webpack_public_path__ + "static/media/alexa3.153e5f90.webp";